import styled from '@emotion/styled';
import { CgClose } from 'react-icons/cg';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /* background:rgba(29, 29, 57, 0.5); ; */

  display: flex;
  justify-content: center;
  /* backdrop-filter: blur(2px); */
  align-items: center;
  z-index: 10;
    @media (max-width: 689px) {
     min-width: 390px;
  } 
`;

export const ModalContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: space-between;
  flex-direction: column;
top:82px ;
 right: 80px;
  border-radius: 16px;

  border: 1px solid var(--colors-grey-100);
box-shadow: 0 12px 48px 0 rgba(71, 84, 103, 0.12);
background: var(--colors-grey-25);
  padding: ${props => props.pad === "false" ? "0" : "28px 20px"};
  position: absolute;
  z-index: 1100;
  height: 589px;
  overflow: hidden;
&.hug{
  height: fit-content;
}
  @media (max-width: 689px) {
     width: 100%;
     min-width: 300px;
     width: 342px;
     right: 24px;
  } 
`;

export const CloseBtn = styled(CgClose)`
  position: absolute;
  top: 14px;
  right: 14px;
  width: 24px;
  height: 24px;
  
  color: var(--colors-grey-400);
  transition: all 250ms cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;

  :hover {
    color: var(--accent);
  }

  @media (min-width: 767px) {
    top: 18px;
    right: 18px;
  }
`;
